import type { LocationVerificationMethod, UpdateOfficeLocationRequest } from '$lib/api/types';

export type OfficeLocationForm = {
	latitude: string;
	longitude: string;
	radiusMeters: number | string;
	verificationMethod: LocationVerificationMethod;
};

export type OfficeLocationValidationResult =
	| { ok: true; request: UpdateOfficeLocationRequest }
	| { ok: false; message: string };

function parseOptionalNumber(value: string): number | null {
	const trimmed = value.trim();
	if (!trimmed) return null;
	const parsed = Number(trimmed);
	return Number.isFinite(parsed) ? parsed : Number.NaN;
}

function parseRadius(value: number | string): number {
	const parsed = typeof value === 'number' ? value : Number(String(value).trim());
	return Number.isFinite(parsed) ? parsed : Number.NaN;
}

export function validateOfficeLocationForm(
	form: OfficeLocationForm
): OfficeLocationValidationResult {
	const latitude = parseOptionalNumber(form.latitude);
	const longitude = parseOptionalNumber(form.longitude);
	const radiusMeters = parseRadius(form.radiusMeters);
	const requiresCoords = form.verificationMethod !== 'NONE';

	if (requiresCoords && (latitude === null || longitude === null)) {
		return { ok: false, message: 'GPS 검증을 사용하려면 사무실 좌표가 필요합니다.' };
	}
	if (Number.isNaN(latitude) || (latitude !== null && (latitude < -90 || latitude > 90))) {
		return { ok: false, message: '위도는 -90부터 90 사이의 숫자로 입력해주세요.' };
	}
	if (Number.isNaN(longitude) || (longitude !== null && (longitude < -180 || longitude > 180))) {
		return { ok: false, message: '경도는 -180부터 180 사이의 숫자로 입력해주세요.' };
	}
	if (Number.isNaN(radiusMeters) || radiusMeters < 50 || radiusMeters > 5000) {
		return { ok: false, message: '허용 반경은 50m부터 5000m 사이로 입력해주세요.' };
	}

	return {
		ok: true,
		request: {
			latitude,
			longitude,
			radiusMeters,
			verificationMethod: form.verificationMethod
		}
	};
}
